(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-ofx-search]').forEach(function (wrap) {
      if (wrap.dataset.ofxSearchInit === '1') return;
      wrap.dataset.ofxSearchInit = '1';
      initSearch(wrap);
    });
  });

  function initSearch(wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var drop  = wrap.querySelector('.ofx-search-drop');
    if (!input || !drop) return;

    var predictiveUrl = wrap.dataset.predictiveUrl || '/search/suggest';
    var searchUrl     = wrap.dataset.searchUrl || '/search';
    var prodLimit     = parseInt(wrap.dataset.productLimit, 10) || 6;
    var linkLimit     = parseInt(wrap.dataset.linkLimit, 10) || 4;
    var emptyTemplate = wrap.dataset.emptyState || 'No instant matches for "{q}". Press Enter to search.';

    var cols    = drop.querySelector('[data-ofx-sd-cols]');
    var allLink = drop.querySelector('[data-ofx-sd-all]');
    var empty   = drop.querySelector('[data-ofx-sd-empty]');
    var loading = drop.querySelector('[data-ofx-sd-loading]');
    var countEl = drop.querySelector('[data-ofx-sd-count]');
    var groups = {
      collections: drop.querySelector('[data-ofx-sd-group="collections"]'),
      pages:       drop.querySelector('[data-ofx-sd-group="pages"]')
    };
    var lists = {
      collections: drop.querySelector('[data-ofx-sd-list="collections"]'),
      pages:       drop.querySelector('[data-ofx-sd-list="pages"]'),
      products:    drop.querySelector('[data-ofx-sd-list="products"]')
    };

    var THUMB_FALLBACK =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
      '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
      '<circle cx="8.5" cy="8.5" r="1.6"/>' +
      '<path d="M21 15l-5-5L5 21"/></svg>';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function hl(text, q) {
      if (!q) return esc(text);
      var t = String(text || '');
      var i = t.toLowerCase().indexOf(q.toLowerCase());
      if (i < 0) return esc(t);
      return esc(t.slice(0, i)) + '<b>' + esc(t.slice(i, i + q.length)) + '</b>' + esc(t.slice(i + q.length));
    }
    function money(v) {
      if (v == null || v === '') return '';
      var n = typeof v === 'number' ? v / 100 : parseFloat(v);
      if (isNaN(n)) return '';
      return '$' + n.toFixed(2);
    }
    function thumbUrl(p) {
      var u = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!u) return '';
      return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120&height=120&crop=center';
    }
    function firstSku(p) {
      if (!p.variants || !p.variants.length) return '';
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i] && p.variants[i].sku) return p.variants[i].sku;
      }
      return '';
    }

    function openDrop() {
      drop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function closeDrop() {
      drop.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
    function showLoading(yes) { loading.hidden = !yes; }
    function showEmpty(q) {
      cols.hidden = true;
      allLink.hidden = true;
      empty.hidden = false;
      empty.textContent = emptyTemplate.replace('{q}', q);
    }

    function renderLinks(listEl, items, q) {
      listEl.innerHTML = items.map(function (it) {
        return '<li><a href="' + esc(it.url) + '">' + hl(it.title, q) + '</a></li>';
      }).join('');
    }
    function renderProducts(prods, q) {
      lists.products.innerHTML = prods.map(function (p) {
        var img = thumbUrl(p);
        var thumb = img
          ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="54" height="54">'
          : THUMB_FALLBACK;
        var hasCompare = p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(p.price_min || p.price || 0);
        var priceHtml = hasCompare
          ? '<span class="ofx-sd-prod__price"><span class="was">' + money(p.compare_at_price_min) +
            '</span><span class="now">' + money(p.price_min || p.price) + '</span></span>'
          : '<span class="ofx-sd-prod__price">' + money(p.price_min || p.price) + '</span>';
        return '<a class="ofx-sd-prod" href="' + esc(p.url) + '">' +
          '<span class="ofx-sd-prod__thumb">' + thumb + '</span>' +
          '<span class="ofx-sd-prod__info">' +
            '<span class="ofx-sd-prod__t">' + hl(p.title, q) + '</span>' +
            priceHtml +
          '</span></a>';
      }).join('');
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = (r.products    || []).slice(0, prodLimit);
      var colls = (r.collections || []).slice(0, linkLimit);
      var pages = (r.pages       || []).slice(0, linkLimit);
      var arts  = (r.articles    || []).slice(0, linkLimit);
      var linkBlog = pages.concat(arts).slice(0, linkLimit);

      if (prods.length + colls.length + linkBlog.length === 0) {
        showEmpty(q);
        return;
      }
      empty.hidden = true; cols.hidden = false; allLink.hidden = false;

      groups.collections.hidden = colls.length === 0;
      groups.pages.hidden       = linkBlog.length === 0;
      cols.classList.toggle('is-no-rail', colls.length === 0 && linkBlog.length === 0);
      renderLinks(lists.collections, colls, q);
      renderLinks(lists.pages, linkBlog, q);
      renderProducts(prods, q);
      countEl.textContent = prods.length ? '(' + prods.length + ')' : '';
      allLink.setAttribute('href', searchUrl + '?q=' + encodeURIComponent(q));
    }

    var debounceTimer = null;
    var abortController = null;
    var loadingTimer = null;

    function fetchSuggest(q) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var u = new URL(predictiveUrl + '.json', location.origin);
      u.searchParams.set('q', q);
      u.searchParams.set('resources[type]', 'product,collection,page,article');
      u.searchParams.set('resources[limit]', String(Math.max(prodLimit, linkLimit)));
      u.searchParams.set('resources[limit_scope]', 'each');
      u.searchParams.set('resources[options][unavailable_products]', 'last');
      u.searchParams.set('resources[options][fields]', 'title,product_type,variants.sku,vendor,tag');

      loadingTimer = setTimeout(function () { showLoading(true); }, 180);

      return fetch(u.toString(), {
        signal: abortController.signal,
        headers: { 'Accept': 'application/json' }
      }).then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error('HTTP ' + res.status));
      }).then(function (data) {
        clearTimeout(loadingTimer); showLoading(false);
        render(data, q);
        openDrop();
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        clearTimeout(loadingTimer); showLoading(false);
        showEmpty(q);
        openDrop();
      });
    }

    function onInput() {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (!q) {
        if (abortController) abortController.abort();
        clearTimeout(loadingTimer); showLoading(false);
        closeDrop();
        return;
      }
      debounceTimer = setTimeout(function () { fetchSuggest(q); }, 150);
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () { if (input.value.trim()) onInput(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrop(); input.blur(); }
    });
    document.addEventListener('click', function (e) {
      if (!drop.contains(e.target) && !input.contains(e.target)) closeDrop();
    });
  }
})();
